import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

const STORAGE_KEY = "caporive-cookie-consent-v1";

function updateConsent(mode) {
  if (typeof window === "undefined") return;
  const w = window;
  w.dataLayer = w.dataLayer || [];
  function gtag() {
    w.dataLayer.push(arguments);
  }
  if (mode === "all") {
    gtag("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      analytics_storage: "granted",
      functionality_storage: "granted",
      personalization_storage: "granted",
    });
  } else if (mode === "essential") {
    gtag("consent", "update", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
      functionality_storage: "granted",
      personalization_storage: "denied",
    });
  } else {
    gtag("consent", "update", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
      functionality_storage: "denied",
      personalization_storage: "denied",
    });
  }
}

export default function CookieBanner() {
  const { lang, t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const persist = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, ts: new Date().toISOString() })
      );
    } catch (e) {
      // localStorage may be unavailable (private mode, iframe restrictions)
    }
    updateConsent(choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-50 border-t-2 border-[#D4AF37] bg-[#0D1B2A] text-white shadow-xl"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-6 md:py-7 grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
        <div className="md:col-span-7">
          <h2
            className="text-lg md:text-xl mb-2"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {t("cookie.title")}
          </h2>
          <p className="text-sm text-white/75 leading-relaxed max-w-2xl">
            {t("cookie.description")}
          </p>
          <Link
            to={`/${lang}/cookies`}
            data-testid="cookie-policy-link"
            className="mt-3 inline-block text-xs uppercase tracking-widest text-[#D4AF37] hover:underline no-underline"
          >
            {t("cookie.policyLink")}
          </Link>
        </div>
        <div className="md:col-span-5 flex flex-col sm:flex-row md:flex-row gap-3 md:justify-end">
          <button
            type="button"
            onClick={() => persist("none")}
            data-testid="cookie-reject-all"
            className="px-5 py-3 text-xs font-semibold uppercase tracking-widest border border-white/30 text-white hover:bg-white/10"
          >
            {t("cookie.rejectAll")}
          </button>
          <button
            type="button"
            onClick={() => persist("essential")}
            data-testid="cookie-essential"
            className="px-5 py-3 text-xs font-semibold uppercase tracking-widest border border-white/30 text-white hover:bg-white/10"
          >
            {t("cookie.preferences")}
          </button>
          <button
            type="button"
            onClick={() => persist("all")}
            data-testid="cookie-accept-all"
            className="px-5 py-3 text-xs font-semibold uppercase tracking-widest bg-[#D4AF37] text-[#0D1B2A] hover:bg-[#c19d2b]"
          >
            {t("cookie.acceptAll")}
          </button>
        </div>
      </div>
    </div>
  );
}
